import { t } from "@lingui/core/macro"
import { addPageAction } from "../../../utils/newrelic"
import { FollowStar } from "../../common/molecules/FollowStar/FollowStar"
import { toast } from "../common/Toast/ToastManager"

const handleLoggedOut = (username: string) => {
    window.location.href = `/auth/login/?next=/${username}/`
}

const afterFollow = (username: string) => {
    toast.fire({
        message: t`Following ${username}`,
        position: "top",
        preset: "dark",
        showIcon: false,
    })
    addPageAction("DmFollow", {
        followAction: "follow",
    })
}

const afterUnfollow = (username: string) => {
    toast.fire({
        message: t`No longer following ${username}`,
        position: "top",
        preset: "dark",
        showIcon: false,
    })
    addPageAction("DmFollow", {
        followAction: "unfollow",
    })
}

export const MessageFollowStar = ({ username }: { username: string }) => {
    return (
        <FollowStar
            username={username}
            afterFollow={afterFollow}
            afterUnfollow={afterUnfollow}
            handleLoggedOut={handleLoggedOut}
        />
    )
}
